import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import { changePeerOrganizationIds } from '../../../store/slice'
import {
  changePrevSelectedCompanyList,
  changeSelectedCompanyList,
  selectPrevSelectedCompanyList,
} from '../popupRecommendationList/store/slice'
import { changeIsShowPopupCancel } from '../store/slice'

export const PopupCancel = ({ isShow, setIsShowRecommendationList }) => {
  const dispatch = useDispatch()
  const prevSelectedCompanyList = useSelector(selectPrevSelectedCompanyList)
  const handleClose = () => {
    dispatch(changeIsShowPopupCancel(false))
  }

  const handleOk = () => {
    const selectedCompanyListIds = prevSelectedCompanyList.map(
      (company) => company.id,
    )
    dispatch(changeIsShowPopupCancel(false))
    dispatch(changeSelectedCompanyList(prevSelectedCompanyList))
    dispatch(changePrevSelectedCompanyList([]))
    dispatch(changePeerOrganizationIds(selectedCompanyListIds))
    setIsShowRecommendationList(false)
  }

  return (
    <PopupAction
      title={'companyAnalysis.peerAnalysis.CONFIRMATION'}
      isShow={isShow}
      btnSubmit={{
        label: 'common.YES',
        isI18n: true,
        event: handleOk,
      }}
      btnCancel={{
        label: 'common.NO',
        isI18n: true,
        event: handleClose,
      }}
      handleClose={handleClose}
    >
      <Translate
        value={'companyAnalysis.peerAnalysis.CANCEL_SAVE_LIST_POPUP_TEXT'}
      />
    </PopupAction>
  )
}
